export function setPermissionsExtra(data) {
  return {
    type: 'SET_PERMISSIONS_EXTRA',
    payload: data,
  };
};